import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PersonSimpleWithRole } from '@app/models/project.models';

export interface EmailPositionFormData {
  position: string | null;
  emailAddress: string | null;
}

export interface EmailPositionFormGroup {
  position: FormControl<string | null>;
  emailAddress: FormControl<string | null>;
}

export function getEmailPositionFormGroup(
  fb: FormBuilder
): FormGroup<EmailPositionFormGroup> {
  return fb.nonNullable.group({
    position: fb.control<string | null>(null),
    emailAddress: fb.control<string | null>(null),
  });
}

export function getEmailPositionFormGroupFromPersonSimpleWithRole(
  fb: FormBuilder,
  person: PersonSimpleWithRole
): FormGroup<EmailPositionFormGroup> {
  return fb.nonNullable.group({
    position: fb.control<string | null>(person.position),
    emailAddress: fb.control<string | null>(person.email),
  });
}

export function getEmailPositionData(
  formGorup: FormGroup<EmailPositionFormGroup>
) {
  return {
    position: formGorup.controls.position.value,
    emailAddress: formGorup.controls.emailAddress.value,
  };
}

export function patchEmailPositionFormWithPersonSimpleWithRole(
  formGroup: FormGroup<EmailPositionFormGroup>,
  person: PersonSimpleWithRole
): void {
  formGroup.controls.position.setValue(person.position);
  formGroup.controls.emailAddress.setValue(person.email);
}

export function getEmailPositionFormValueFromPersonSimpleWithRole(
  person: PersonSimpleWithRole | null
): EmailPositionFormData {
  return {
    position: person === null ? null : person.position,
    emailAddress: person === null ? null : person.email,
  };
}
